import { 
    getRecommandTenantList
    } from "@/apis/company/recommandTenant.js"; 
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_checkbox_status: 'bizRecommandTenant/set_checkbox_status',
    set_recommand_tenant: 'bizRecommandTenant/set_recommand_tenant',
    set_selected_house: 'bizRecommandTenant/set_selected_house',
    set_instead_loadlord_id: 'bizRecommandTenant/set_instead_loadlord_id',
    set_instead_group_id: 'bizRecommandTenant/set_instead_group_id',
    set_instead_sales_id: 'bizRecommandTenant/set_instead_sales_id',
    set_filter_query: 'bizRecommandTenant/set_filter_query',
    set_success_list: 'bizRecommandTenant/set_success_list',
    set_org_group_list: 'bizRecommandTenant/set_org_group_list',
    set_member_by_group: 'bizRecommandTenant/set_member_by_group',
}

// count state 必須是 Object
const state = {
    bizRecommandTenantList: [],
    checkboxStatus: {
        checkboxAll: false,
    },
    selectedHouse: [],
    insteadLandlordId: null,
    insteadGroupAndSales: {
        groupId: null,
        agentId: null
    },
    filterQuery: {},
    filterQueryUpdate: 0,
    successList: [],
    organizationGroupList: [],
    memberByGroupList: [],
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_RECOMMAND_TENANT_LIST: (state) => {
        return state.bizRecommandTenantList
    },
    GET_BIZ_RECOMMAND_TENANT_SUCCESS_LIST: (state) => {
        return state.successList
    },
    GET_BIZ_RECOMMAND_TENANT_LIST_TOTAL: (state) => {
        return state.bizRecommandTenantList.length
    },
    GET_BIZ_RECOMMAND_TENANT_CHECKBOX_STATUS: (state) => {
        return state.checkboxStatus
    },
    GET_BIZ_RECOMMAND_TENANT_HAS_SELECTED_HOUSE: (state) => {
        return state.selectedHouse.length?true:false
    },
    GET_BIZ_RECOMMAND_TENANT_SELECTED_HOUSE_CID: (state) => {
        return state.selectedHouse
    },
    GET_BIZ_RECOMMAND_TENANT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_RECOMMAND_TENANT_FILTER_QUERY_UPDATE: (state) => {
        return state.filterQueryUpdate
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizRecommandTenantList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            getRecommandTenantList(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let batchDispatch = res.data.result
                    commit(types.set_recommand_tenant, batchDispatch)
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizRecommandTenantCheckboxStatus ( {commit}, data ) {
        commit(types.set_checkbox_status, data)
    },
    setBizRecommandTenantSeletedHouse ( {commit}, data ) {
        commit(types.set_selected_house, data)
    },
    setBizRecommandTenantFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_checkbox_status](state, data){
        state.checkboxStatus = data
    },
    [types.set_selected_house](state, data){
        state.selectedHouse = data
    },
    [types.set_recommand_tenant](state, data){
        state.bizRecommandTenantList = data
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.filterQueryUpdate += 1
    },
    [types.set_success_list](state, data){
        if(data){
            state.successList = data
        }else{
            state.successList = state.selectedHouse
        }
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/personalHome/recommandTenant.js